const decrementCounter = (property, setCounters, counters) => {
    console.log("Decrementing: " + property)
    if ((property === "HomeShotAndGoal" || property === "VisitorShotAndGoal")) {
        let goal = 'VisitorGoal';
        let shot = 'VisitorShot';
        if (property === "HomeShotAndGoal") {
            goal = 'HomeGoal';
            shot = 'HomeShot';
        }
        setCounters({
            ...counters,
            [goal]: counters[goal] - 1,
            [shot]: counters[shot] - 1,
        });
    }
    else {
        setCounters({
            ...counters,
            [property]: counters[property] - 1,
        });
    }
};
// Function to increment a specific counter
const incrementCounter = (property, setCounters, counters) => {
    if ((property === "HomeShotAndGoal" || property === "VisitorShotAndGoal")) {
        let goal = 'VisitorGoal';
        let shot = 'VisitorShot';
        if (property === "HomeShotAndGoal") {
            goal = 'HomeGoal';
            shot = 'HomeShot';
        }
        setCounters({
            ...counters,
            [goal]: counters[goal] + 1,
            [shot]: counters[shot] + 1,
        });
    }
    else {
        setCounters({
            ...counters,
            [property]: counters[property] + 1,
        });
    }
};


export { decrementCounter, incrementCounter }


